import { render, staticRenderFns } from "./InsightsView.vue?vue&type=template&id=34890c8a&"
import script from "./InsightsView.vue?vue&type=script&lang=js&"
export * from "./InsightsView.vue?vue&type=script&lang=js&"
import style0 from "./InsightsView.vue?vue&type=style&index=0&id=34890c8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports